export default __webpack_public_path__ + "static/media/Gruesome_1@2x.27e53728.jpg";